<template>
  <div class="terms-page">
    <PageTitle pageTitle="TERMS OF USE"></PageTitle>
    <Terms></Terms>
  </div>
</template>
<script>
import Terms from "@/components/Terms/Terms";
// import PageTitle from "@/components/PageTitle/PageTitle";
export default {
  components: {
    Terms,
    // PageTitle
  }
};
</script>
